<template>
  <div class="row">
    <div :class="['col_12', {'loading_overlay': loading}]">
      <div class="card no_border">
        <div class="card-header">
          <div class="card-title">{{ pageName }}</div>
        </div>
        <div class="card-body pl_0 pr_0">
          <div class="row">
            <div class="col_3">
              <div class="form-group ">
                  <label>{{ $t('sidebar.adminMember.admin_id') }}</label>
                  <input type="text" class="form_global"  v-model="form.admin_id">
                  <v-errors :errors="errorFor('admin_id')"></v-errors>
              </div>
            </div>
            <div class="col_3">
              <div class="form-group ">
                  <label>{{ $t('common.name') }}</label>
                  <input type="text" class="form_global"  v-model="form.name">
                  <v-errors :errors="errorFor('name')"></v-errors>
              </div>
            </div>
            <div class="col_3">
              <div class="form-group ">
                  <label>{{ $t('common.password') }}</label>
                  <input type="text" class="form_global"  v-model="form.password">
                  <v-errors :errors="errorFor('password')"></v-errors>
              </div>
            </div>
            <div class="col_3">
              <div class="form-group ">
                  <label>{{ $t('common.phone') }}</label>
                  <input type="text" class="form_global"  v-model="form.phone">
                  <v-errors :errors="errorFor('phone')"></v-errors>
              </div>
            </div>
            <div class="col_3">
                <div class="form-group">
                    <label>{{ $t('common.situation') }}</label>
                    <select class="form_global" id="situation" v-model="form.situation">
                        <option value="">{{ $t('common.select') }}</option>
                        <option value="approval">{{ $t('common.approval') }}</option>
                        <option value="stop">{{ $t('common.stop') }}</option>
                        <option value="dormancy">{{ $t('common.dormancy') }}</option>
                        <option value="secession">{{ $t('common.secession') }}</option>
                    </select>
                    <v-errors :errors="errorFor('situation')"></v-errors>
                </div>
            </div>
            <div class="col_3">
                <div class="form-group">
                    <label>{{ $t('sidebar.adminMember.rating') }}</label>
                    <select class="form_global" id="rating" v-model="form.rating">
                        <option value="">{{ $t('common.select') }}</option>
                        <option value="system">{{ $t('sidebar.adminMember.system') }}</option>
                        <option value="top-level">{{ $t('sidebar.adminMember.top_level') }}</option>
                        <option value="teacher">{{ $t('sidebar.adminMember.teacher') }}</option>
                    </select>
                    <v-errors :errors="errorFor('rating')"></v-errors>
                </div>
            </div>
          </div>
          <div class="d_flex_end form_action_btn">
            <router-link class="btn btn_danger ml_10" :to="{name: cancelRouteName}">{{ $t('common.cancel') }}</router-link>
            <button class="btn btn_blue ml_10" @click.prevent="submitForm">{{ $t('common.save') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'admin-form',
  components: {},
  data() {
    return {
      pageName: this.$t('sidebar.adminMember.addAdmin'),
      cancelRouteName: 'members_admin',
      form: {
        admin_id: '',
        name: '',
        password: '',
        phone: '',
        situation: '',
        rating: '',
      }
    }
  },
  created() {
    if (this.$route.name === 'member_admin_edit') {
      this.axios.get('/admins/'+this.$route.params.id)
        .then((response) => {
          this.form = response.data.data;
          delete this.form.id;
        })
      this.pageName = this.$t('sidebar.adminMember.editAdmin');
    }
  },
  methods: {
    submitForm() {
      this.allErrors = null;
      this.loading = true;

      if (this.$route.name === 'member_admin_edit') {
        this.axios.patch('/admins/'+this.$route.params.id, this.form)
          .then(() => {
            this.$router.push({name: 'members_admin'});
            this.showSuccessMsg(this.$t('common.updateSuccess'))
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.axios.post('/admins', this.form)
          .then(() => {
            this.$router.push({name: 'members_admin'});
            this.showSuccessMsg(this.$t('common.addSuccess'))
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
}
</script>
